import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import * as actions from '../../../../store/actions';
import { getAssetCostSupplierDetails } from '../../../../store/actions';
import { toast } from 'react-toastify';
import { closeModal } from '../../../../components/Modal/modalReducer';
import SupplierDetailsForm from '../../../Shared/CostManager/SupplierDetails/SupplierDetailsForm/SupplierDetailsForm';
import Supplier from '../../../Shared/CostManager/ContractDetails/ContractDetailsEdit/Supplier';
import { getForm } from '../../../Shared/CostManager/ContractDetails/ContractDetailsEdit/form';
import Transition from '../../../../components/Transition';

const CostManagerEditModal = ({ data, assetId }) => {
  const supplier = useSelector((state) => state.assetCostManager.supplier);
  const contractDetails = useSelector((state) => state.assetCostManager.details);

  const dispatch = useDispatch();

  const [supplierForm, setSupplierForm] = React.useState({});
  const [contractDetailsForm, setContractDetailsForm] = React.useState({});

  const primaryContractDetails = useMemo(
    () => (!!contractDetails ? contractDetails[0] : null),
    [contractDetails]
  );

  useEffect(() => {
    dispatch(getAssetCostSupplierDetails(data.id));
    dispatch(actions.getAssetCostContractDetails(data.id));
  }, [data]);

  useEffect(() => setSupplierForm(supplier), [supplier]);
  useEffect(() => {
    const primaryContractDetailsData = primaryContractDetails?.typedata
      ? JSON.parse(primaryContractDetails?.typedata)
      : {};

    setContractDetailsForm(
      !!primaryContractDetails ? getForm(primaryContractDetails, primaryContractDetailsData) : {}
    );
  }, [primaryContractDetails]);

  const handleSave = () => {
    dispatch(actions.updateAssetCostSupplierDetails({ ...supplierForm, id: supplier.id }))
      .then(() =>
        dispatch(
          actions.updateAssetCostContractDetails(primaryContractDetails.id, contractDetailsForm)
        )
      )
      .then(() => dispatch(closeModal()))
      .then(() => toast.success('Cost Manager updated successfully'))
      .then(() => dispatch(actions.getAssetCostManager(assetId)));
  };

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  return (
    <Dialog
      open
      onClose={handleCloseModal}
      TransitionComponent={Transition}
      keepMounted
      fullWidth={true}
      maxWidth="md"
    >
      <Box bgcolor="#2C324D" p={2} display="flex" mb={2} color="white" alignItems="center">
        <DialogTitle id="alert-dialog-slide-title">Edit Cost Manager "{data.name}"</DialogTitle>
      </Box>
      <DialogContent>
        <Accordion defaultExpanded style={{ marginBottom: '20px' }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography style={{ marginRight: '20px' }}>Supplier Details</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <SupplierDetailsForm loading={false} details={supplier} formChanged={setSupplierForm} />
          </AccordionDetails>
        </Accordion>
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography style={{ marginRight: '20px' }}>Contract Details</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Supplier form={contractDetailsForm} setForm={setContractDetailsForm} />
          </AccordionDetails>
        </Accordion>
      </DialogContent>
      <DialogActions>
        <Box p={2} display="flex" flexWrap="wrap">
          <Box ml={2} mr={2}>
            <Button onClick={handleCloseModal} color="secondary" variant="outlined">
              Cancel
            </Button>
          </Box>
          <Button
            onClick={handleSave}
            color="primary"
            variant="contained"
            disabled={
              !supplierForm?.companyname ||
              new Date(contractDetailsForm?.startdate).getTime() >
                new Date(contractDetailsForm?.enddate).getTime()
            }
          >
            Save
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default CostManagerEditModal;
